///* Clase en desuso temporal

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import {
  ActivarInstalacionOperacionForm,
  Agenda,
  EstadoOrdenTrabajoCodigoEnum,
  EstadoPyLCodigoEnum,
} from '@/shared/interfaces';
import {
  OrdenTrabajoOld,
  OrdenTrabajoWithProspectoData,
} from '@/shared/interfaces/erp/tecnico';
import { useUiStore } from '@/store/ui';

const { put, post } = erpApi();

// visualizar tabla & upd orden_w

///* tanSctack query
export const useUpdOrdenTrabajoActivacion = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateOTActivacion,
    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: ['ordenesTrabajo'] });

      if (res.status === 'success')
        return navigate(returnUrl, { replace: true });
    },
  });
};

export const useAprovePreRechazoOTActivacion = (
  navigate: NavigateFunction,
  returnUrl: string,
  showAlert?: boolean
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updOTActivacionReject,
    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: ['ordenesTrabajo'] });

      if (res.status === 'success' && showAlert) {
        const setAlert = useUiStore.getState().setAlert;

        setAlert(true, 'Pre rechaazo aprobado con éxito', 'success');
        return navigate(returnUrl, { replace: true });
      }
    },
  });
};

export const useCreateScheduleToRecordinate = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createNewScheduleToRecordinate,
    onSuccess: res => {
      const setAlert = useUiStore.getState().setAlert;
      queryClient.invalidateQueries({ queryKey: ['agendas'] });

      if (res.status === 'success') {
        setAlert(true, 'Recoordinación exitosa', 'success');
        return navigate(returnUrl, { replace: true });
      }
      if (res.status === 'error') {
        setAlert(true, res.message, res.status);
      }
    },
  });
};

///* axios
export type ActivacionPendienteParams = Pick<
  OrdenTrabajoOld,
  | 'nap'
  | 'direccion_ip'
  | 'observacion'
  | 'tipo_instalacion'
  | 'estado'
  | 'estado_activacion'
  | 'fecha_hora_activacion'
  | 'user'
>;

// reject OT - Aprove PreRechazo
export type RechazoFormData = {
  motivo?: string;
  estado: EstadoOrdenTrabajoCodigoEnum;
  fecha_hora_activacion: string; // hora rechazo
  estado_activacion: string;
};
export type RejectOTActivacionParams = {
  id: string;
  data: RechazoFormData;
};

export const updateOTActivacion = async ({
  id,
  data,
}: {
  id: string;
  data: ActivarInstalacionOperacionForm;
}) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<OrdenTrabajoOld>(
    `${urlBackend}api/v1/ordenes-trabajo/${id}/`,
    data,
    true
  );

  setAlert(true, res.message, res.status);
  return res;
};

// aprove and reject preRechazo set rechazado
export const updOTActivacionReject = async (
  params: RejectOTActivacionParams
) => {
  const res = await put<OrdenTrabajoOld>(
    `${urlBackend}api/v1/ordenes-trabajo/${params.id}/`,
    params.data,
    true
  );

  return res;
};

// recoordinar OT tras NO aprobar PreRechazo
export const useCreateOTActivacionRecoordinada = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createOTActivacionRecoordinada,
    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: ['ordenesTrabajo'] });

      if (res.status === 'success') {
        setAlert(true, 'Recoordinación exitosa', 'success');
      }

      navigate(returnUrl, { replace: true });
    },
  });
};

export type RecoordinarOTActivacionParams = {
  id: string;
  data: Partial<OrdenTrabajoWithProspectoData>;
};

export const createOTActivacionRecoordinada = async ({
  data,
  id,
}: RecoordinarOTActivacionParams) => {
  return post<OrdenTrabajoWithProspectoData>(
    `${urlBackend}api/v1/ordenes-trabajo/${id}/`,
    data,
    true
  );
};

////* Schedule ------
export type CreateNewScheduleToRecordinateParams = Partial<Agenda>;

export const createNewScheduleToRecordinate = async (
  data?: CreateNewScheduleToRecordinateParams
) => {
  return post<Agenda>(`${urlBackend}api/v1/agendas/`, data, true);
};

////* Pyl set hora inicio y fin
export type SetHoraInicioHoraFinOTPyLForm = {
  hora_inicio: string;
  hora_fin: string;
  user: number;
  estado_pyl?: EstadoPyLCodigoEnum;
};
export type SetHoraInicioHoraFinOTPyLParams = {
  id: string;
  data: SetHoraInicioHoraFinOTPyLForm;
};

export const useUpdOTPyLHoraInicioHoraFin = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updOTPyLHoraInicioHoraFin,
    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: ['ordenesTrabajo'] });

      if (res.status === 'success') {
        setAlert(
          true,
          'Hora de inicio y fin establecidas con éxito',
          'success'
        );
      }

      return navigate(returnUrl, { replace: true });
    },
  });
};

export const updOTPyLHoraInicioHoraFin = async (
  params: SetHoraInicioHoraFinOTPyLParams
) => {
  return put<OrdenTrabajoOld>(
    `${urlBackend}api/v1/ordenes-trabajo/${params.id}/`,
    params.data,
    true
  );
};